import { z } from "zod";

export const AuthProviderSchema = z.enum(["kakao", "google"]);
export type AuthProvider = z.infer<typeof AuthProviderSchema>;

export const CURRENT_TERMS_VERSION = "1.0";

// Unique @handle — 친구 검색의 정확 식별자(닉네임은 표시명, 중복 허용).
// 입력 검증·정규화 전담. trim → 형식검사 → 소문자화. 저장은 항상 소문자.
export const HandleSchema = z
  .string()
  .trim()
  .regex(/^[A-Za-z0-9_]{3,20}$/, "핸들은 영문/숫자/_ 3–20자만 가능해요")
  .transform((s) => s.toLowerCase());

// Full internal schema — do NOT serialize directly to API responses.
export const UserSchema = z.object({
  id: z.string().uuid(),
  provider: AuthProviderSchema,
  providerId: z.string(),          // OAuth sub
  email: z.string().email().nullable(),
  nickname: z.string().min(1).max(50),
  handle: z.string(),              // 유니크 식별자(소문자 저장). 검증은 HandleSchema.
  avatarUrl: z.string().url().nullable(),
  createdAt: z.number().int(),
  lastLoginAt: z.number().int(),
  termsVersion: z.string().default("1.0"),          // 마지막 동의한 약관 버전
  termsAcceptedAt: z.number().int().default(0),     // 0 = 미동의
});
export type User = z.infer<typeof UserSchema>;

// Rule: sensitive fields are removed via .omit() (not .optional()) so the
// type no longer exposes them — prevents accidental inclusion in responses.
//
// PublicUserSchema — shape returned to other users (non-self).
// Also strips email to prevent cross-user email leakage.
export const PublicUserSchema = UserSchema.omit({
  providerId: true,
  lastLoginAt: true,
  email: true,
  termsVersion: true,
  termsAcceptedAt: true,
});
export type PublicUser = z.infer<typeof PublicUserSchema>;

// SelfUserSchema — shape returned only to the authenticated user (/api/auth/me, /api/users/me/*).
// Keeps email (needed on own profile) but still omits internal fields.
export const SelfUserSchema = UserSchema.omit({
  providerId: true,
  lastLoginAt: true,
});
export type SelfUser = z.infer<typeof SelfUserSchema>;
